module.exports = __webpack_public_path__ + "static/media/ic-cloud-tech.e295c227.svg";